import http from "@/common/request";
const url = require("../url");

//登录
export function LoginJWTToken(params) {
  return http.get(url.LoginJWTToken, params);
}
// 获取用户信息
export function GetInfoByToken(params) {
  return http.get(url.GetInfoByToken, params)
}
// 获取路由数
export function GetNavigationBar(params) {
  return http.get(url.GetNavigationBar, params)
}
// 登出
export function apiLoginLogOut(params) {
  return http.get(url.apiLoginLogOut, params)
}
// 获取学历列表
export function educationGet(params) {
  return http.get(url.educationGet, params)
}
// 获取学位列表
export function degreeGet(params) {
  return http.get(url.degreeGet, params)
}
// 地点联查
export function DeployDistrictGet(params) {
  return http.get(url.DeployDistrictGet, params)
}
// 用户获取个人权限
export function PersonGetAllUsers() {
  return http.post(url.PersonGetAllUsers)
}
// 个人更新用户信息
export function PersonPostUserInfo(data) {
  return http.post(url.PersonPostUserInfo, data)
}
// 获取个人工作经历
export function identityresumePage(data) {
  return http.post(url.identityresumePage, data)
}
// 添加工作经历
export function identityresumePost(data) {
  return http.post(url.identityresumePost, data)
}
// 修改工作经历
export function identityresumePut(data) {
  return http.put(url.identityresumePut, data)
}
// 删除工作经历
export function identityresumeDelete(params) {
  return http.delete(url.identityresumeDelete, params)
}
// 上传图片
export function PicUploadToRemote(data) {
  return http.post(url.PicUploadToRemote, data)
}
// 用户申请加入企业
export function UserAuditPost(data) {
  return http.post(url.UserAuditPost, data)
}
// 退出企业
export function QuitEnterprisePost(data) {
  return http.post(url.QuitEnterprisePost, data)
}
// 查询退出企业记录
export function QuitEnterpriseQuery(params) {
  return http.get(url.QuitEnterpriseQuery, params)
}
// 查询申请企业记录
export function UserAuditUserQuery(data) {
  return http.post(url.UserAuditUserQuery, data)
}
// 企业入驻
export function EnterpriseAuditSubmit(data) {
  return http.post(url.EnterpriseAuditSubmit, data)
}
// 查询申请企业状态
export function EnterpriseAuditQueryState() {
  return http.delete(url.EnterpriseAuditQueryState)
}
// 用户查询课程列表
export function CourseUserQuery(data) {
  return http.post(url.CourseUserQuery, data)
}
// 获取课时详情
export function CourseHourGet(params) {
  return http.get(url.CourseHourGet, params)
}
// 上传人脸底图
export function AddUserFacePhoto(data) {
  return http.post(url.AddUserFacePhoto, data)
}
// 实名认证
export function UserPhotoUserAuth(data) {
  return http.post(url.UserPhotoUserAuth, data)
}
// 查询我的课程列表
export function OwnCourseQuery(data) {
  return http.post(url.OwnCourseQuery, data)
}
// 查询我的计划
export function OwnPlanQuery(data) {
  return http.post(url.OwnPlanQuery, data)
}
// 获取我的计划课程列表
export function OwnCourseOwnPlanCourseQuery(data) {
  return http.post(url.OwnCourseOwnPlanCourseQuery, data)
}
// 查询我的题库
export function OwnQuestionBankQuery(data) {
  return http.post(url.OwnQuestionBankQuery, data)
}
//查询我的收藏
export function CourseCollectQuery(data) {
  return http.post(url.CourseCollectQuery, data)
}
//查询错题列表
export function GetErrorQuestionDetailList(data) {
  return http.post(url.GetErrorQuestionDetailList, data)
}
//删除错题
export function DeleteErrorQuestion(params) {
  return http.delete(url.DeleteErrorQuestion, params)
}
//查询评价列表
export function EvaluateQuery(data) {
  return http.post(url.EvaluateQuery, data)
}
//添加评价
export function EvaluatePost(data) {
  return http.post(url.EvaluatePost, data)
}
//查询用户订单
export function OwnOrderQueryUserOrder(data) {
  return http.post(url.OwnOrderQueryUserOrder, data)
}
//获取我的积分
export function GetOwnIntegral(params) {
  return http.get(url.GetOwnIntegral, params)
}
//查询积分来源去向
export function QueryIntegralOrigin(data) {
  return http.post(url.QueryIntegralOrigin, data)
}
//查询题库列表
export function QuestionLibCollectQuery(data) {
  return http.post(url.QuestionLibCollectQuery, data)
}
//查询素材库库收藏列表
export function SmlibCollectQuery(data) {
  return http.post(url.SmlibCollectQuery, data)
}
//用户查询题库列表
export function QuestionLibraryUserQuery(data) {
  return http.post(url.QuestionLibraryUserQuery, data)
}
//用户查询资源库列表
export function smlibraryUserGet(data) {
  return http.post(url.smlibraryUserGet, data)
}
//查询我的题库
export function GetQuestionLibrary(params) {
  return http.get(url.GetQuestionLibrary, params)
}
//获取试题类型
export function QuestionClassifyQuery(data) {
  return http.post(url.QuestionClassifyQuery, data)
}
// 查询我的素材
export function OwnSmlibraryQuery(data) {
  return http.post(url.OwnSmlibraryQuery, data)
}
//我的素材库详情
export function OwnSmlibraryGetSmlib(params) {
  return http.get(url.OwnSmlibraryGetSmlib, params)
}
//微信扫码支付
export function WeChatPayQrCodePay(data) {
  return http.post(url.WeChatPayQrCodePay, data)
}
//订单状态查询
export function GetOrderState(params) {
  return http.get(url.GetOrderState, params)
}
//生成订单
export function GetOutTradeNoPage(data) {
  return http.post(url.GetOutTradeNoPage, data)
}
//电脑网站
export function AlipayPcPay(data) {
  return http.post(url.AlipayPcPay, data)
}
//获取每日一练考题
export function OwnEveryDayTaskGetPaperInfo(params) {
  return http.get(url.OwnEveryDayTaskGetPaperInfo, params)
}
// 查询我的计划试卷
export function OwnPaperOwnPlanPaperQuery(data) {
  return http.post(url.OwnPaperOwnPlanPaperQuery, data)
}
// 获取计划试卷详情
export function OwnPaperGetOwnPaperInfo(params) {
  return http.get(url.OwnPaperGetOwnPaperInfo, params)
}
// 获取模拟考核试卷题目
export function OwnPaperGetOwnPaperQuestion(params) {
  return http.get(url.OwnPaperGetOwnPaperQuestion, params)
}
// 获取练习题目
export function OwnPaperGetOwnPaperDrillQuestion(data){
  return http.post(url.OwnPaperGetOwnPaperDrillQuestion,data)
}
// 提交试卷
export function OwnPaperCommitPaper(data) {
  return http.post(url.OwnPaperCommitPaper, data)
}
// 获取课程详情
export function OwnCourseGetCourse(data) {
  return http.post(url.OwnCourseGetCourse, data)
}
// 添加收藏
export function OwnCollectPost(data) {
  return http.post(url.OwnCollectPost, data)
}
// 取消收藏
export function OwnCollectDelete(params) {
  return http.delete(url.OwnCollectDelete, params)
}
// 获取验证码
export function GetValidateCode(params) {
  return http.get(url.GetValidateCode, params)
}
// 验证码注册登录
export function LoginPhoneLogin(params) {
  return http.get(url.LoginPhoneLogin, params)
}
// 获取我的题库题目
export function GetOwnLibQuestion(data) {
  return http.post(url.GetOwnLibQuestion, data)
}
// 获取课程设置详情
export function GetCourseSet(params){
  return http.get(url.GetCourseSet,params)
}
// 设置在学
export function IsLessonStudy(params){
  return http.get(url.IsLessonStudy,params)
}
// 添加课程进度
export function AddLesson(data){
  return http.post(url.AddLesson,data)
}
// 获取我的课时信息
export function GetCourseHourByid(params){
  return http.get(url.GetCourseHourByid,params)
}
// 人脸识别校验
export function UserFaceAuth(data){
  return http.post(url.UserFaceAuth,data)
}
// 提交答题记录
export function CommitRightOrErrorRecode(data){
  return http.post(url.CommitRightOrErrorRecode,data)
}
// 每日一练是否完成答题
export function GetTodayState(){
  return http.get(url.GetTodayState)
}
// 提交每日一练
export function OwnEveryDayTaskCommitPaper(data){
  return http.post(url.OwnEveryDayTaskCommitPaper,data)
}
// 获取每日一练记录
export function OwnEveryDayTaskQuery(data){
  return http.post(url.OwnEveryDayTaskQuery,data)
}
// 获取每日一练详情
export function OwnEveryDayTaskGet(params){
  return http.get(url.OwnEveryDayTaskGet,params)
}
// 每月一考是否完成答题
export function GetMonthState(){
  return http.get(url.GetMonthState)
}
// 获取每月一考考题
export function OwnEveryMonthTaskGetPaperInfo(){
  return http.get(url.OwnEveryMonthTaskGetPaperInfo)
}
// 每月一考提交
export function OwnEveryMonthTaskCommitPaper(data){
  return http.post(url.OwnEveryMonthTaskCommitPaper,data)
}
// 获取每月一考记录
export function OwnEveryMonthTaskQuery(data){
  return http.post(url.OwnEveryMonthTaskQuery,data)
}
// 每月一考详情
export function OwnEveryMonthTaskGet(params){
  return http.get(url.OwnEveryMonthTaskGet,params)
}
// 每周一课历史课程
export function OwnEveryWeekTaskQuery(data){
  return http.post(url.OwnEveryWeekTaskQuery,data)
}
// 免费加入课程
export function FreeAddCourse(params){
  return http.get(url.FreeAddCourse,params)
}
// 获取课时列表
export function GetCourseHourList(data){
  return http.post(url.GetCourseHourList,data)
}
// 免费加入题库
export function OwnQuestionBankFreeAddCourse(params){
  return http.get(url.OwnQuestionBankFreeAddCourse,params)
}
// 获取新闻列表
export function NewsGetNewsList(){
  return http.get(url.NewsGetNewsList)
}
// 获取公告列表
export function NoticeGetNewsList(){
  return http.get(url.NoticeGetNewsList)
}
// 免费加入素材库
export function FreeAddSoftware(params){
  return http.get(url.FreeAddSoftware,params)
}
// 素材库素材列表
export function UserGetSmfileList(data){
  return http.post(url.UserGetSmfileList,data)
}
// 开始学习每周一课
export function OwnEveryWeekTaskStartStudy(){
  return http.get(url.OwnEveryWeekTaskStartStudy,)
}
// 获取计划人脸配置
export function PlanGetPlanFaceConfig(params){
  return http.get(url.PlanGetPlanFaceConfig,params)
}
// 保存练习进度
export function OwnQuestionBankSaveSchedule(data){
  return http.post(url.OwnQuestionBankSaveSchedule,data)
}
// 获取教师列表
export function LecturerGetLecturer(data){
  return http.post(url.LecturerGetLecturer,data)
}
// 用户获取列表
export function UserGetSoftwareList(data){
  return http.post(url.UserGetSoftwareList,data)
}
// 启动软件
export function StartSoftwareServer(data){
  return http.post(url.StartSoftwareServer,data)
}
// 获取我的软件详情
export function GetSoftwareInfo(params){
  return http.get(url.GetSoftwareInfo,params)
}
// 更新每周一课学习进度
export function UpdateTaskProgross(data){
  return http.post(url.UpdateTaskProgross,data)
}
// 删除计划人员
export function PlanDelPlanUser(data){
  return http.post(url.PlanDelPlanUser,data)
}
// 保存计划练习答题进度
export function OwnPaperSaveSchedule(data){
  return http.post(url.OwnPaperSaveSchedule,data)
}
// 课程笔记查询
export function CourseNoteQuery(data){
  return http.post(url.CourseNoteQuery,data)
}
// 添加笔记
export function CourseNotePost(data){
  return http.post(url.CourseNotePost,data)
}
// 删除笔记
export function CourseNoteDeleteNote(params){
  return http.get(url.CourseNoteDeleteNote,params)
}
// 重置管理员密码
export function UpdatePwd(params) {
  return http.post(url.UpdatePwd, params)
}
// 获取计划试卷列表
export function OwnPlanCoursePaperList(params){
  return http.get(url.OwnPlanCoursePaperList,params)
}
// 获取计划试卷练习题
export function OwnCoursePaperGetPracticeQuestion(data){
  return http.post(url.OwnCoursePaperGetPracticeQuestion,data)
}
// 保存练习进度
export function OwnCoursePaperSaveSchedule(data){
  return http.post(url.OwnCoursePaperSaveSchedule,data)
}
// 获取模拟或考试题
export function OwnCoursePaperGetPaperQuestion(params){
  return http.get(url.OwnCoursePaperGetPaperQuestion,params)
}
// 提交试卷
export function OwnCoursePaperCommitPaper(data){
  return http.post(url.OwnCoursePaperCommitPaper,data)
}

// 获取我的数据
export function StatisticsGetMyData(params){
  return http.get(url.StatisticsGetMyData,params)
}
// 查询招聘信息
export function EmployInfoPageList(data){
  return http.post(url.EmployInfoPageList,data)
}
// 增加招聘信息
export function AddEmployInfo(data){
  return http.post(url.AddEmployInfo,data)
}
// 修改招聘信息
export function UpdateEmployInfo(data){
  return http.post(url.UpdateEmployInfo,data)
}
// 删除招聘信息
export function DeleteEmployInfo(params){
  return http.get(url.DeleteEmployInfo,params)
}
// 投递信息查询
export function ResumeInfoPageList(data){
  return http.post(url.ResumeInfoPageList,data)
}
// 投递简历
export function AddResumeInfo(data){
  return http.post(url.AddResumeInfo,data)
}
// 查询员工活动
export function StaffActivityPageList(data){
  return http.post(url.StaffActivityPageList,data)
}
// 添加员工活动
export function AddStaffActivity(data){
  return http.post(url.AddStaffActivity,data)
}
// 删除员工活动
export function DeleteStaffActivity(data){
  return http.post(url.DeleteStaffActivity,data)
}
// 删除简历信息
export function DeleteResumeInfo(data){
  return http.post(url.DeleteResumeInfo,data)
}
// 查询培训类别
export function GetTrainClassify(){
  return http.get(url.GetTrainClassify)
}
// 查询二级类别
export function TrainClassifyGetChildrenList(params){
  return http.get(url.TrainClassifyGetChildrenList,params)
}
// 获取答题记录
export function GetPaperRecordList(data){
  return http.post(url.GetPaperRecordList,data)
}
// 获取试卷详情
export function GetPaperQuestionRecord(params){
  return http.get(url.GetPaperQuestionRecord,params)
}
